const BASE = "/api/v1";

export class ApiError extends Error {
  constructor(public status: number, message: string, public payload?: unknown) {
    super(message);
  }
}

export async function api<T = unknown>(
  path: string,
  init: RequestInit & { json?: unknown } = {},
): Promise<T> {
  const { json, headers, ...rest } = init;
  const res = await fetch(`${BASE}${path}`, {
    headers: {
      ...(json !== undefined ? { "Content-Type": "application/json" } : {}),
      ...headers,
    },
    body: json !== undefined ? JSON.stringify(json) : (rest.body as BodyInit | undefined),
    ...rest,
  });
  if (res.status === 204) return undefined as T;
  const text = await res.text();
  const payload = text ? safeParse(text) : null;
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    if (payload && typeof payload === "object" && "detail" in payload) {
      detail = String((payload as { detail: unknown }).detail);
    }
    throw new ApiError(res.status, detail, payload);
  }
  return payload as T;
}

function safeParse(text: string): unknown {
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}
